import { Role, toRole } from '../role.js';
import { AccessCodeBaseEnum, accessCodeIsVisible, accessCodePublishTime, emptyAccessCodeFeature, toAccessCodeFeature } from './features/accessCodeFeature.js';
const toSiteFeature = (raw) => {
    return {
        description: raw.description || '',
        defaults: raw.defaults || '',
        enabled: !!raw.enabled,
        role: toRole(raw.role),
        params: raw.params ?? {}
    };
};
const toSiteFeatures = (raw) => {
    const features = defaultSiteFeatures();
    if (!raw)
        return features;
    if (raw.cards)
        features.cards = toSiteFeature(raw.cards);
    if (raw.coupons)
        features.coupons = toSiteFeature(raw.coupons);
    if (raw.clubCodes)
        features.clubCodes = toSiteFeature(raw.clubCodes);
    if (raw.groups)
        features.groups = toSiteFeature(raw.groups);
    if (raw.accessCodes) {
        features.accessCodes = toAccessCodeFeature(raw.accessCodes);
    }
    if (raw.paypal)
        features.paypal = toSiteFeature(raw.paypal);
    if (raw.stripe)
        features.stripe = toSiteFeature(raw.stripe);
    if (raw.vipps)
        features.vipps = toSiteFeature(raw.vipps);
    if (raw.noPayment)
        features.noPayment = toSiteFeature(raw.noPayment);
    if (raw.invoice)
        features.invoice = toSiteFeature(raw.invoice);
    if (raw.devOverrides)
        features.devOverrides = toSiteFeature(raw.devOverrides);
    if (raw.events)
        features.events = toSiteFeature(raw.events);
    if (raw.mail)
        features.mail = toSiteFeature(raw.mail);
    if (raw.lights)
        features.lights = toSiteFeature(raw.lights);
    return features;
};
const emptySiteFeature = (enabled, role) => {
    return {
        description: '',
        defaults: '',
        enabled,
        role,
        params: {}
    };
};
const defaultSiteFeatures = () => {
    return {
        cards: emptySiteFeature(false, Role.everyone),
        accessCodes: emptyAccessCodeFeature(false, Role.everyone),
        coupons: emptySiteFeature(true, Role.everyone),
        noPayment: emptySiteFeature(true, Role.bookie),
        paypal: emptySiteFeature(false, Role.everyone),
        stripe: emptySiteFeature(false, Role.everyone),
        vipps: emptySiteFeature(false, Role.everyone),
        invoice: emptySiteFeature(false, Role.everyone),
        clubCodes: emptySiteFeature(false, Role.everyone),
        groups: emptySiteFeature(false, Role.everyone),
        devOverrides: emptySiteFeature(false, Role.system),
        events: emptySiteFeature(false, Role.everyone),
        mail: emptySiteFeature(true, Role.everyone),
        lights: emptySiteFeature(false, Role.everyone)
    };
};
export { toSiteFeatures, emptySiteFeature, defaultSiteFeatures, accessCodePublishTime, accessCodeIsVisible, AccessCodeBaseEnum };
//# sourceMappingURL=features.js.map